const API_URL =
  process.env.REACT_APP_API_URL || "https://avex-backend-u4ay.onrender.com";

// -------- CATEGORIES --------
export async function getCategories() {
  const res = await fetch(`${API_URL}/api/categories`);
  if (!res.ok) throw new Error("Failed to fetch categories");
  return res.json();
}

// -------- PRODUCTS --------
export async function getProducts({ category = "", search = "" } = {}) {
  const params = new URLSearchParams();

  // only send category if it actually exists
  if (category && category !== "all") {
    params.append("category", category);
  }

  // only send search if not empty
  if (search && search.trim() !== "") {
    params.append("search", search.trim());
  }

  const url = params.toString()
    ? `${API_URL}/api/products?${params.toString()}`
    : `${API_URL}/api/products`;

  const res = await fetch(url);
  if (!res.ok) throw new Error("Failed to fetch products");
  return res.json();
}
